{
  "name": "cupoui",
  "version": "1.0.0",
  "private": true,
  "description": "Description for cupoui",
  "license": "UNLICENSED",
  "type": "module",
  "scripts": {
    "ng": "ng",
    "start": "node --max_old_space_size=5000 ./node_modules/@angular/cli/bin/ng serve && npm run version",
    "build": "node --max_old_space_size=5000 ./node_modules/@angular/cli/bin/ng build --configuration production",
    "prod": "node --max_old_space_size=5000  ./node_modules/@angular/cli/bin/ng build --configuration production && npm run version",
    "test": "ng test --browsers=Chrome ",
    "test:local": "ng test --karma-config karma.conf.local.js",
    "test:ci": "ng test  --browsers ChromeHeadless",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "stats": "ng build --configuration production --stats-json",
    "bundle-report": "webpack-bundle-analyzer dist/Secca/stats.json",
    "version": "node_modules/.bin/replace-env src/environments/build.txt"
  },
  "dependencies": {
    "@angular/animations": "21.2.19",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.19",
    "@angular/compiler": "21.2.19",
    "@angular/core": "21.2.19",
    "@angular/forms": "21.2.19",
    "@angular/google-maps": "20.2.14",
    "@angular/localize": "21.2.19",
    "@angular/material": "21.2.14",
    "@angular/material-moment-adapter": "21.2.14",
    "@angular/platform-browser": "21.2.19",
    "@angular/platform-browser-dynamic": "21.2.19",
    "@angular/router": "21.2.19",
    "@fortawesome/angular-fontawesome": "4.0.0",
    "@fortawesome/fontawesome-svg-core": "6.4.2",
    "@fortawesome/free-solid-svg-icons": "6.4.2",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@ng-select/ng-select": "^21.0.0",
    "@ngneat/until-destroy": "10.0.0",
    "@ngx-translate/core": "18.0.0",
    "@ngx-translate/http-loader": "18.0.0",
    "@popperjs/core": "~2.11.8",
    "@videogular/ngx-videogular": "^7.0.1",
    "bootstrap": "5.2.0",
    "bootswatch": "5.2.0",
    "chart.js": "^3.9.1",
    "dayjs": "1.11.5",
    "file-saver": "2.0.5",
    "heic2any": "0.0.4",
    "keycloak-angular": "^21.0.0",
    "keycloak-js": "^25.0.6",
    "lodash": "^4.18.1",
    "luxon": "1.28.1",
    "moment": "2.29.4",
    "moment-timezone": "0.5.43",
    "ng-click-outside2": "^16.0.0",
    "ng-flex-layout": "^21.0.0",
    "ng-multiselect-dropdown": "1.0.0",
    "ng2-charts": "^3.1.2",
    "ng2-pdf-viewer": "10.0.0",
    "ngx-cookie-service": "^21.3.1",
    "ngx-infinite-scroll": "21.0.0",
    "ngx-logger": "5.0.12",
    "ngx-mask": "21.1.0",
    "ngx-webstorage": "21.0.1",
    "rxjs": "7.8.1",
    "tslib": "2.4.0",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/schematics": "^21.2.19",
    "@angular-eslint/eslint-plugin": "^19.0.0",
    "@angular/build": "^21.2.19",
    "@angular/cli": "21.2.19",
    "@angular/compiler-cli": "21.2.19",
    "@angular/service-worker": "21.2.19",
    "@types/core-js": "^2.5.6",
    "@types/file-saver": "2.0.5",
    "@types/google.maps": "3.55.12",
    "@types/luxon": "1.25.0",
    "@types/node": "^22.9.0",
    "@types/tableau": "^2.2.6",
    "@typescript-eslint/eslint-plugin": "8.65.0",
    "@typescript-eslint/parser": "8.65.0",
    "@typescript-eslint/utils": "^8.65.0",
    "browser-sync": "3.0.4",
    "concurrently": "7.3.0",
    "dotenv": "^17.4.2",
    "eslint": "^9.39.5",
    "eslint-config-prettier": "^9.1.2",
    "folder-hash": "4.0.2",
    "husky": "7.0.4",
    "lint-staged": "13.0.3",
    "prettier": "3.9.6",
    "prettier-plugin-packagejson": "3.0.2",
    "replace-env": "^1.0.4",
    "rimraf": "3.0.2",
    "swagger-ui-dist": "4.14.0",
    "ts-node": "~7.0.0",
    "typescript": "^5.9.3",
    "wait-on": "6.0.1",
    "webpack-bundle-analyzer": "4.6.1"
  }
}
